import { Box, Stack, Typography } from '@mui/material';
import { UserDetailsQuery } from '@/__generated__/graphql';
import { FALLBACK_INSPECTION_IMAGE } from '@/constants';
import { getCloudfrontUrl } from '@/utils/cloudfront';

type Props = {
  structure: UserDetailsQuery['userDetails']['structures'][0];
};
export const UserPlatformCard = ({ structure }: Props) => {
  return (
    <Stack direction={'row'} gap={2}>
      <Box sx={{ width: '8%' }}>
        <img
          loading="lazy"
          alt={structure.name}
          src={getCloudfrontUrl(structure.coverImagePath || FALLBACK_INSPECTION_IMAGE)}
          onError={(event) => {
            const reference = event.currentTarget;
            reference.src = FALLBACK_INSPECTION_IMAGE;
          }}
          crossOrigin="use-credentials"
          style={{
            width: '100%',
            borderRadius: '8px',
          }}
        />
      </Box>
      <Box sx={{ ml: 1 }}>
        <Typography fontSize={16} fontWeight={600} color="#323C50">
          {structure.name}
        </Typography>
        <Typography fontSize={12} fontWeight={400} color={'#6E8198'}>
          {structure.description}
        </Typography>
      </Box>
    </Stack>
  );
};
